(() => {
  if (!customElements.get('cb-mobile-slider')) customElements.define('cb-mobile-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('[data-slider-track]');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const position = this.querySelector('[data-position]');
      if (!track || !prev || !next) return;
      const cards = [...track.children];
      const update = () => {
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        const index = Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / (step || 1))));
        position.textContent = (index + 1) + ' / ' + cards.length;
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => {
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
      });
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); this.ready = false; }
  });
  if (!customElements.get('cb-ice-calculator')) customElements.define('cb-ice-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const inputs = [...this.querySelectorAll('[data-calc]')];
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'EUR',maximumFractionDigits:0});
      const update = () => {
        const values = {};
        inputs.forEach(input => {
          const n = input.valueAsNumber;
          values[input.dataset.calc] = Number.isFinite(n) ? Math.min(Number(input.max),Math.max(0,n)) : 0;
        });
        const services = values.bottles * values.days;
        const ice = services * values.kg * values.price;
        const staff = services * values.minutes / 60 * values.wage;
        this.querySelector('[data-result="ice"]').textContent = money.format(ice);
        this.querySelector('[data-result="staff"]').textContent = money.format(staff);
        this.querySelector('[data-result="total"]').textContent = money.format(ice + staff);
      };
      this.addEventListener('input', update);
      update();
    }
  });
})();